import { Spin, DatePicker } from "antd";
import axios from "axios";
import React, { useContext, useRef, useState } from "react";
import moment from "moment";

import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";

import PsContext from "../../context";

import {
    MOB_ICONS,
    getFileLiveUrl,
    sleep,
    upperCase,
    yearBySem,
    S3_BUCKET_HOME_PATH, siteUrl
} from "../../utils";
import { PAGE_LAYOUT, PAGE_SIZE } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import { useLocation, useNavigate } from "react-router-dom";


const AddConvocation = (props) => {
    const context = useContext(PsContext);
    const [loader, setLoader] = useState(false);
    const location = useLocation();

    const buttonRef = useRef(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [dataList, setDataList] = useState([]);
    const [selMonth, setSelMonth] = useState(moment());
    const [dataView, setDataView] = useState(props.dataSource);

    const [editorContent, setEditorContent] = useState("");

    const [validated, setValidated] = useState(false);

    // const field = (fieldName) => {
    //     return dataList && dataList[fieldName];
    // };



    // const handleFormSubmit = (e) => {
    //     e.preventDefault();
    //     const form = e.currentTarget;
    //     if (form.checkValidity() === false) {
    //         e.stopPropagation();
    //         setValidated(true);
    //         return;
    //     }
    //     if (!window.confirm("Do you want to save ?")) return;
    //     setLoader(true);

    //     axios
    //         .post(ServiceUrl.STUDENTS.SAVE_CONVOCATION, new FormData(form))
    //         .then((res) => {
    //             if (res["data"].status == "1") {
    //                 document.getElementById("frm_save").reset();
    //                 if (props.onSuccess) props.onSuccess();
    //                 toast.success(res.data.message || "Student Saved");
    //                 //  toast.success(res["data"].message || "Error");

    //                 //setEditorContent("");
    //             } else {
    //                 toast.error(res["data"].message || "Error");
    //             }
    //             setLoader(false);
    //         });
    // };



    const handleFormSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }
        if (!window.confirm("Do you want to save ?")) return;
        setLoader(true);
        const formData = new FormData(form);

        formData.append("registerno", context.user.registerno);
        formData.append("course_name", context.user.course_name);

        axios
            .post(ServiceUrl.STUDENTS.SAVE_CONVOCATION, formData)
            .then((res) => {
                if (res.data.status == "1") {
                    document.getElementById("frm_save").reset();
                    if (props.onSuccess) props.onSuccess();
                    toast.success(res.data.message || "Student Saved");
                } else {
                    toast.error(res.data.message || "Error");
                }
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("An error occurred while saving.");
                setLoader(false);
            });
    };

    // const studentField = (fieldName) => {
    //     if (selectedCourse && selectedCourse[fieldName])
    //         return selectedCourse[fieldName];
    // };

    // const getContent = () => {
    //     let ar = [];



    //     ar["{{registerno}}"] = context.user("registerno");
    //     ar["{{student_name}}"] = field("student_name");
    //     ar["{{mother_name_tamil}}"] = field(
    //         "mother_name_tamil"
    //     );
    //     ar["{{mother_name}}"] = field(
    //         "mother_name"
    //     );

    //     ar["{{father_name}}"] = field("father_name");
    //     ar["{{father_name_tamil}}"] = field("father_name_tamil");
    //     ar["{{gender}}"] = field("gender");
    //     ar["{{college_name}}"] = field("college_name");
    //     ar["{{yearofpassing}}"] = field("yearofpassing");
    //     ar["{{address}}"] = field("address");
    //     ar["{{pincode}}"] = field("pincode");
    //     ar["{{mobile_no}}"] = field("mobile_no");
    //     ar["{{email}}"] = field("email");
    //     ar["{{mother_mobile_number}}"] = field("mother_mobile_number");
    //     ar["{{father_mobile_number}}"] = field("father_mobile_number");
    //     ar["{{student_name_tamil}}"] = field("student_name_tamil");
    //     ar["{{course_name}}"] = field("course_name");

    //     let x = bulkReplace(
    //         //field("certificate_content"),
    //         Object.keys(ar),
    //         Object.values(ar)
    //     );
    //     return x;
    // };


    // const handleFormSubmit = (e) => {
    //     e.preventDefault();
    //     const form = e.currentTarget;
    //     if (form.checkValidity() === false) {
    //         e.stopPropagation();
    //         setValidated(true);
    //         return;
    //     }
    //     if (!window.confirm("Do you want to save ?")) return;
    //     setLoader(true);
    //     const formData = new FormData(form);

    //     formData.append("registerno", context.user.registerno);
    //     formData.append("course_name", context.user.course_name);
    //     formData.append("getcontent", getContent());

    //     //getContent();
    //     axios
    //         .post(ServiceUrl.STUDENTS.SAVE_CONVOCATION, form)
    //         .then((res) => {
    //             if (res["data"].status == "1") {
    //                 .success(res["data"].message || "Success");
    //                 // printDocument("print_stu_bonafied");
    //                 if (props.onHide) props.onHide();
    //                 window.open(siteUrl + "files_list/" + res["data"].file_path);
    //                 //  resetAll();
    //             } else {
    //                 toast.error(res["data"].message || "Error");
    //             }
    //             setLoader(false);
    //         });
    // };


    const field = (fieldName) => {
        console.log('ttt', props.dataSource);
        if (dataView && dataView[0][fieldName])
            return dataView[0][fieldName];
    };

    return (
        <>
            <Spin spinning={loader}>

                <Form
                    method="post"
                    noValidate
                    validated={validated}
                    id="frm_save"
                    onSubmit={handleFormSubmit}
                >


                    <input type="hidden" name="registerno" value={context.user.registerno} />
                    <input type="hidden" name="course_name" value={context.user.course_name} />
                    {/* <input type="hidden" name="getcontent" value={getContent()} /> */}


                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Student Name In English</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="student_name"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Student Name In Tamil(தமிழில்)</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="student_name_tamil"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Father Name In English</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="father_name"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Father Name In Tamil (தமிழில்)</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="father_name_tamil"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Mother Name In English</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="mother_name"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Mother Name In Tamil (தமிழில்)</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="mother_name_tamil"
                                required
                            />
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Gender</label>
                            <Form.Control
                                as="select"
                                className="fw-bold form-select form-select-sm"
                                size="sm"
                                name="gender"
                            >
                                <option value="">Select</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="transgender">Transgender</option>

                            </Form.Control>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Name of the College</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="college_name"
                                required
                            />
                        </Col>
                    </Row>

                    <Row className="mt-2">

                        <Col md={12}>
                            <label>Month & Year of Passing</label>
                            <Form.Control
                                type="month"
                                className="fw-bold text-uppercase mt-2"
                                size="sm"
                                name="yearofpassing"
                                required
                            />
                        </Col>


                    </Row>


                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Address</label>
                            <Form.Control
                                type="text"
                                className="fw-bold "
                                size="sm"
                                name="address"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Pincode</label>
                            <Form.Control
                                type="pincode"
                                className="fw-bold "
                                size="sm"
                                name="pincode"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Mobile Number</label>
                            <Form.Control
                                type="number"
                                className="fw-bold "
                                size="sm"
                                name="mobile_no"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Email ID</label>
                            <Form.Control
                                type="email"
                                className="fw-bold "
                                size="sm"
                                name="email"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Father Mobile Number</label>
                            <Form.Control
                                type="phone"
                                className="fw-bold "
                                size="sm"
                                name="father_mobile_number"
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={12}>
                            <label>Mother Mobile Number</label>
                            <Form.Control
                                type="phone"
                                className="fw-bold "
                                size="sm"
                                name="mother_mobile_number"
                                required
                            />
                        </Col>
                    </Row>
                    {/* <Row className="mt-3 mb-4">
                        <Col md={12}>
                            <div className="text-end">
                                <Button type="submit" size="sm" ref={buttonRef}>
                                    <i className="fa-solid fa-check fs-6 px-1"></i>Update
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                    <Row className="mt-3">
                        <Col md={12}>
                            <div className="text-end">
                                <Button type="submit" size="sm">
                                    <i className="fa-solid fa-check me-2"></i>Save
                                </Button>
                            </div>
                        </Col>
                    </Row>

                </Form>
            </Spin >
        </>
    );
};
export default AddConvocation;
